import OrderHistoriesShow from '../../../components/pages/mypages/OrderHistoriesShow.vue'

export default {
  components: {
    OrderHistoriesShow
  }
}
